module.exports = __webpack_public_path__ + "img/infoqMeeting-intro.e8063e56.png";